import { CommitResourcesRequest, GrowerProgramsAPI, WorkflowsAPI } from '@cibo/core'
import { QUERY_KEY as LAND_MANAGER_QUERY_KEY } from '@cibo/landmanager'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { logRequestError } from '@cibo/ui'
import { AxiosError } from 'axios'
import { useState } from 'react'
import { PROGRAMS_QUERY_KEY } from './queryKey'

export const usePreflightCheck = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<AxiosError>()
  const [data, setData] = useState<any>()

  return {
    mutateAsync: async (request: CommitResourcesRequest) => {
      if (!request.resourceIds.length) return
      setIsLoading(true)
      return await GrowerProgramsAPI.commit({
        ...request,
        dryRun: true,
      })
        .then(data => setData(data))
        .catch(error => {
          setError(error)
          if (![400, 409].includes(error.response?.status || -1)) {
            logRequestError(error)
          }
        })
        .finally(() => setIsLoading(false))
    },
    isLoading,
    error,
    data,
  }
}

export const useCommitFields = ({ onSuccess }: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient()

  return useMutation(
    async (request: CommitResourcesRequest, workflowId?: string) => {
      const response = await GrowerProgramsAPI.commit(request)
      workflowId && (await WorkflowsAPI.deleteWorkflow(workflowId))
      return response
    },
    {
      onSuccess: (event, request) => {
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.COMMIT_COUNTS])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.ACTIVE_CARD, request.programId])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAMS, request.programId])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAM_GROWERS])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAM_STATS])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAM_STATS_ORG])
        queryClient.invalidateQueries([LAND_MANAGER_QUERY_KEY.FIELDS_PAGINATED])
        queryClient.invalidateQueries([LAND_MANAGER_QUERY_KEY.FIELD_STATS])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAM_STATUS_AGGREGATE_FIELDCOUNT])
        queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAM_STATUS_FIELDCOUNTS])

        request.resourceIds.forEach((resourceId: any) => {
          queryClient.invalidateQueries([LAND_MANAGER_QUERY_KEY.FIELDS, resourceId])
        })

        onSuccess && onSuccess()
      },
    }
  )
}
